import React from 'react';
import styles from './Enquiries.module.css';

const EnquiryStatusBadge = ({ status }) => {
  const getStatusConfig = (status) => {
    switch (status) {
      case 'new_enquiry':
        return {
          label: 'New',
          className: styles.statusBadgeNew,
          showPulse: true
        };
      case 'in_conversation':
        return {
          label: 'In Conversation',
          className: styles.statusBadgeInConversation,
          showPulse: false
        };
      case 'archived':
        return {
          label: 'Archived',
          className: styles.statusBadgeArchived,
          showPulse: false
        };
      default:
        return {
          label: 'Unknown',
          className: styles.statusBadgeDefault,
          showPulse: false
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <span className={`${styles.statusBadge} ${config.className}`}>
      {config.showPulse && (
        <span className={`${styles.statusDot} ${styles.statusDotPulse}`} />
      )}
      {config.label}
    </span>
  );
};

export default EnquiryStatusBadge;